<div [class]="viewModel?.params?.colDef?.field + 'Container'" *ngrxLet="viewModel$; let viewModel;">
  <div class="lineContainer">
                  <span class="differencesContainer"
                        [innerHTML]="viewModel?.params?.valueFormatted">
                  </span>
    <!-- new tab trigger -->
    <!-- stopped event propagation coz clicking the icon would select the difference otherwise-->
    @if (viewModel?.isUrl) {
      <a
          mat-icon-button
          [href]="viewModel.params.value | prependProtocol"
          target="_blank" class="open-url-element"
          appGtagEvent trackOn="click" action="open link/photo"
          category="Navigation [overhaul]"
          [params]="{ event_label: 'Open link/photo from BLS updates popup' }">
        <mat-icon svgIcon="open_in_new"></mat-icon>
      </a>
    }
  </div>
</div>
